{
    "services-personalized-advisors": {
        "meta": {
            "title": "Servicio al cliente con asesores personales - MAJORITY",
            "description": "Nuestro servicio al cliente habla tu idioma. Obtén ayuda con MAJORITY de cualquiera de nuestros asesores personales capacitados. ¡Contacta con nosotros!"
        },
        "hero": {
            "title": "Si necesitas ayuda contacta con nuestro servicio al cliente",
            "body": "Servicio al cliente dedicado en tu propio idioma siempre que lo necesites",
            "cta": "Comenzar",
            "features": "Servicio al cliente dedicado\nContenido seleccionado de la comunidad"
        },
        "we_speak_content_box": {
            "tagline": "Asesores personales",
            "title": "Hablamos tu idioma",
            "body": "Tenemos asesores personales listos para ayudarte en cualquier momento en tu propio idioma. La mayoría de nuestros asesores personales también son migrantes, por lo que conocen de forma personal lo difícil que puede ser sentar los cimientos financieros en un nuevo país. Ya sea que tengas preguntas sobre tu cuenta, la tarjeta de débito Visa®, envíos de dinero y recargas o llamadas internacionales, nuestro exclusivo servicio de atención al cliente está aquí para ayudarte.",
            "canvas": "¿En qué podemos ayudarte?"
        },
        "welcome_content_box": {
            "tagline": "Asesores personales",
            "title": "Bienvenido al barrio",
            "body": "Ya sea que tengas preguntas sobre finanzas personales, cómo crear un presupuesto o cómo adaptarte a la vida en los Estados Unidos, podrás encontrar respuestas en nuestros contenidos seleccionados. Descubre historias inspiradoras sobre miembros de nuestra comunidad, líderes empresariales locales y emprendedores migrantes. ¡Comparte tu historia con nosotros para tener la oportunidad de aparecer en nuestro sitio web!",
            "cta": "Visita la comunidad"
        }
    }
    
}